import { jsx as _jsx } from "react/jsx-runtime";
export function ClockIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M8 4.66667V8H11.3333M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14Z",
      stroke: "#6E7781",
      strokeWidth: "1.25",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}